
import React, { useMemo } from 'react'
import MarketLine from 'smartstream-widgets/components/MarketLine/MarketLine'
import ShowMore from 'smartstream-widgets/controls/ShowMore/ShowMore'
import { getHighestPriceInMarkets } from 'smartstream-widgets/utils/markets'

import { PanelProps } from './types'

export default function OddsComparisonPanel(Props: PanelProps) {
  const {
    bookmakers = {},
    isBookmakerLinkEnabled,
    classes,
    competitionId,
    competitors,
    fixtureId,
    index,
    isAwayTeamFirst,
    markets,
    oddsFormat,
    tabIndex,
    translations
  } = Props

  const highestPrice = useMemo(() => getHighestPriceInMarkets(markets), [markets])

  return (
    <div
      role='tabpanel'
      hidden={tabIndex !== index}
      id={`full-width-tabpanel-${index}-${fixtureId}`}
    >
      <div>
        <ShowMore
          classes={{ buttonText: classes.showMoreText, button: classes.showMoreButton }}
          showMoreText={translations.showMore}
          showLessText={translations.showLess}
        >
          {
            markets && markets.map((market) => {
              return (
                <MarketLine
                  affiliateLabel={'offertext'}
                  animationKey={market.marketTypeId + market.sourceId}
                  bookmakers={bookmakers}
                  isBookmakerLinkEnabled={isBookmakerLinkEnabled}
                  classes={{
                    affiliateText: classes.affiliateText,
                    bestSelection: classes.bestSelection,
                    buttonDisabled: classes.buttonDisabled,
                    captionOdd: classes.captionOdd,
                    icon: classes.bookmakerIcon,
                    iconContainer: classes.iconContainer,
                    iconOfferText: classes.offerText,
                    oddButton: classes.oddButton,
                    oddButtonWithDraw: classes.oddButtonWithDraw,
                    root: classes.marketOddLines,
                    rootDraw: classes.marketOddLinesDraw,
                    rootDrawLink: classes.marketOddLinesDrawLink,
                    oddsContainerDraw: classes.marketOddsContainerDraw
                  }}
                  highestPrice={highestPrice}
                  competitionId={competitionId}
                  competitors={competitors}
                  isAwayTeamFirst={isAwayTeamFirst}
                  key={`${market.sourceId}-${market.marketTypeId}`}
                  labelSet={'european'}
                  marketTypeId={market.marketTypeId}
                  selections={market.selections}
                  showAffiliateLogo
                  showIconAlways
                  oddsFormat={oddsFormat}
                  showIconOfferText
                  sourceId={market.sourceId}
                />
              )
            })
          }
        </ShowMore>
      </div>
    </div>
  )
}
